<template>
  <div class="full-body-content align-items-center">
    <b-row class="v-full justify-content-center">
      <b-col md="8" xl="5" align-self="center">
        <b-card-group>
          <b-card no-body class="p-4">
            <b-card-body>
              <b-form>
                <h1 v-text="$t('menu.login')">Login</h1>
                <p class="text-muted">{{ $t('other.log_in_to_your_account_by_email') }}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="cui-envelope-closed"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input id="input_email" type="email" class="form-control" v-model.trim="email" autocomplete="email"
                                @keydown.native.space.prevent
                                aria-describedby="inputFeedback_email"
                                :placeholder="$t('menu.email')" :state="checkEmail" />
                  <b-form-invalid-feedback id="inputFeedback_email">
                    <!-- This will only be shown if the preceeding input has an invalid state -->
                    Ex. abc@defg.com
                  </b-form-invalid-feedback>
                </b-input-group>
                

                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type="password" class="form-control" v-model.trim="password" autocomplete="current-password"
                                @keydown.native.space.prevent
                                aria-describedby="inputFeedback_password"
                                :placeholder="$t('menu.password')" :state="checkPassword" />
                  <b-form-invalid-feedback id="inputFeedback_password">
                    <!-- This will only be shown if the preceeding input has an invalid state -->
                    6 to 20 characters which contain at least one numeric digit, one uppercase and one lowercase letter
                  </b-form-invalid-feedback>
                </b-input-group>
               
                <b-row>
                  <b-col cols="8">
                    <b-button variant="success" class="px-4 btn_login" 
                              @click="onLogin"
                              :disabled="disabledLoginBtn"
                    >{{ $t('menu.login') }}</b-button>

                    <div v-if="error_massage" class="btn_tips">
                      <div v-if="error_code == '403'">{{ $t('other.disabled_login') }}</div>
                      <div v-else>{{ $t('other.wrong_login') }}</div>
                    </div>

                  </b-col>
                  <b-col cols="4" class="text-right">
                    <b-button variant="link" class="px-0" :to="{ name:'Forget Password' }">{{ $t('menu.forgot_password') }} ?</b-button>
                  </b-col>
                </b-row>
              </b-form>
              <!-- <hr>
              <b-row>
                <b-col cols="12" sm="6" align-self="center">
                </b-col>
                <b-col cols="12" sm="6" class="block-right">
                  <b-button variant="success" class="btn-register" :to="{ name:'Register' }">{{ $t('other.register_now') }}</b-button>
                </b-col>
              </b-row> -->
            </b-card-body>
          </b-card>
          <!--
          <b-card no-body class="text-white bg-success py-5 " >
            <b-card-body class="text-center">
              <div>
                <h2>{{ $t('other.join_agriweather') }}</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <b-button variant="success" class="active mt-4 btn-register" size="lg" :to="{ name:'Register' }">{{ $t('other.register_now') }}</b-button>
              </div>
            </b-card-body>
          </b-card>
          -->
        </b-card-group>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Login',
    data () {
      return {
        email: '',
        password: '',

        state_email: undefined,
        error_massage: false,
        error_code: 401,
      }
    },
    mounted ()
    {
      // 進到此頁直接登出
      if ( localStorage.token )
      {
        this.$store.dispatch('user/logout')
          .then(  res => {})
          .catch( err => {})
      }
      
      window.addEventListener("keyup", this.detect_keyup);
    },
    computed: {

      ...mapState({
          'user_history': state => state.user.location_history,
      }),

      checkEmail ()
      {
        return this.$tools.input.checkEmail(this.email)
      },
      checkPassword ()
      {
        if (this.password == '') return undefined
        return this.$tools.input.checkPassword(this.password)
      },
      disabledLoginBtn ()
      {
        this.error_massage = false
        return ! (this.checkEmail && this.checkPassword)
      },
    },
    methods: {

      detect_keyup (event)
      {
        if ( this.disabledLoginBtn == false )
        {
          // keyCode：13 (enter)
          if ( event.keyCode == 13 )
          {
            this.onLogin()
          }
        }
      },

      onLogin ()
      {
        const { email, password } = this
        const data = {
          "email": email,
          "password": password
        }

        const options = {
          method:'POST',
          data: data,
          url: this.$config.getAPI_URL('Login'),
        }
        this.$http(options)
          .then( res => {

            // 如果回傳的資料有 access_token 表示登入成功
            if ( res.data.access_token )
            {
                // 如果有紀錄登入前紀錄使用者當時在哪個頁面就導過去
                if ( this.user_history != undefined )
                {
                    location.href = this.user_history
                    this.$store.commit('user/setHistory', undefined)
                }
                else
                {
                    this.$router.push( { name: 'Home' } );
                }
            }

          })
          .catch( err => {
            // 登入失敗
            // 驗證后端回傳的錯誤訊息
            // axios 配置里必须要 return Promise.reject(error.response.data) 才能拿到錯誤訊息
            this.error_massage = true
            this.error_code = err.data.status
          })
      }
    }
  }
</script>


<style lang="scss" scoped>
  .btn_login
  {
    margin-right: 10px;
  }
  .btn_tips
  {
    display: inline-block;
    color: #c9707f;
  }

  .block-right
  {
    text-align: center;
    @media only screen and (min-width: 650px)
    {
        text-align: right;
    }
  }
  .btn-register
  {
    width: 90%;
    text-align: center;
  }
</style>
